import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled, { css } from 'styled-components';
import { brand } from '@helpers/brand';
import Button from '../../Buttons/Button/Button';
import SvgTick from '@img/icons/tick.svg';
import { h5 } from '@helpers/typography';
import srOnly from '@helpers/srOnly';
import { m } from 'framer-motion';
import { Layers } from '@helpers/layers';
import SvgChevronDown from '@img/icons/chevron-down-thin.svg?url';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import { rgba } from 'polished';
const Container = styled.section `
  @media ${from(Device.TabletLarge)} {
    padding: 24px;
    position: sticky;
    top: 230px;
  }

  @media ${from(Device.Desktop)} {
    padding: 24px 0;
  }
`;
const Title = styled.h3 `
  ${h5}
`;
const ActiveFilters = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const ActiveTab = styled.button `
  ${fonts.montserrat.medium};
  border: 1px solid ${brand.green.dark};
  border-radius: 5000000000px;
  background-color: ${rgba(brand.green.dark, 0.2)};
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  line-height: 32px;
  padding: 0 10px;
  gap: 10px;

  svg {
    height: 12px;
    margin-left: 5px;
  }
`;
const ActiveFiltersBase = styled.div `
  margin-top: 10px;
`;
const ClearBtn = styled.button `
  ${fonts.montserrat.medium};
  border: none;
  background-color: transparent;
  text-decoration: underline;
  font-size: 16px;
  line-height: 32px;
`;
const FilterBtn = styled.button `
  ${fonts.montserrat.medium};
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  border: none;
  border-bottom: 2px solid ${brand.green.seafoam};
  border-radius: 0;
  padding: 15px 0;
  width: 100%;
  font-size: 16px;
  line-height: 32px;

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
    line-height: 34px;
  }

  svg {
    width: 20px;
  }

  ${({ active }) => active &&
    css `
      ${fonts.montserrat.bold};

      svg {
        transform: rotate(180deg);
      }
    `}
`;
const FilterOptions = styled(m.div) `
  overflow: hidden;
`;
const CheckboxFilterHolder = styled.div ``;
const Checkbox = styled.div ``;
const CheckboxInput = styled.input `
  ${srOnly}
`;
const Tick = styled(SvgTick) `
  position: absolute;
  left: 19px;
  top: 18px;
  color: ${brand.white};
  width: 16px;
  opacity: 0;
  z-index: 1;
`;
const CheckboxLabel = styled.label `
  ${fonts.montserrat.medium};
  display: block;
  font-size: 16px;
  line-height: 32px;
  position: relative;
  padding: 8px 10px 8px 55px;
  width: 100%;
  cursor: pointer;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 12px;
    left: 15px;
    width: 20px;
    height: 20px;
    border: 2px solid ${brand.green.dark};
    border-radius: 2px;
    transition: background-color 0.3s;
  }

  ${CheckboxInput}:checked + & {
    &:before {
      background-color: ${brand.green.dark};
    }
    ${Tick} {
      opacity: 1;
    }
  }
`;
const FilterList = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: scroll;
    padding: 20px;
  }
`;
const Filter = styled.div `
  display: block;
  flex: 1 1 auto;
  position: relative;
  margin-top: 15px;
`;
const FilterDropdown = styled.select `
  ${fonts.montserrat.regular};
  display: block;
  width: 100%;
  border: 2px solid ${brand.black};
  border-radius: 8px;
  appearance: none !important;
  background: none;
  background-color: ${brand.white};
  background-image: url('${SvgChevronDown}');
  background-repeat: no-repeat;
  background-position: center right 12px;
  background-size: 20px 10px;
  color: ${brand.black};
  font-size: 16px;
  line-height: 20px;
  height: 56px;
  padding: 0 30px 0 12px;
  width: 100%;
  cursor: pointer;

  @media ${from(Device.Desktop)} {
    font-size: 18px;
    line-height: 20px;
  }
`;
const FilterSearch = styled.input `
  ${fonts.montserrat.regular};
  display: block;
  appearance: none;
  border: 2px solid ${brand.black};
  border-radius: 8px;
  color: ${brand.black};
  font-size: 16px;
  line-height: 20px;
  height: 56px;
  padding: 0 30px 0 12px;
  flex: 1 0 auto;

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
  }
`;
const FilterOverflow = styled.div `
  overflow-y: auto;
  height: calc(100vh - 160px);

  @media ${from(Device.TabletLarge)} {
    height: 40vh;
    padding-right: 20px;
  }
`;
const SearchFilterBtnHolder = styled.div `
  @media ${until(Device.TabletLarge)} {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px 20px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
  }
`;
const FilterSearchBtn = styled(Button) `
  height: 56px;
  margin-top: 40px;
  width: 100%;
  text-align: center;
  justify-content: center;

  @media ${until(Device.TabletLarge)} {
    height: 48px;
    margin-top: 0;
  }

  ${ButtonStyles.IconWrapper} {
    margin-right: 0;
  }
`;
const FilterHolder = styled(m.div) ``;
const SelectLabel = styled.label `
  ${srOnly};
`;
const ItemContainer = styled.div ``;
const Background = styled.div `
  @media ${until(Device.TabletLarge)} {
    position: fixed;
    top: 0;
    right: 0;
    background: ${brand.black};
    height: 100%;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease-out;
    width: 100%;
    z-index: ${Layers.Modal - 1};

    [aria-active='true'] & {
      opacity: 0.85;
      pointer-events: all;
    }
  }
`;
const Overlay = styled.div `
  @media ${until(Device.TabletLarge)} {
    position: fixed;
    top: 0;
    left: 0;
    background: ${brand.white};
    height: 100%;
    transform: translateX(-100vw);
    transition: transform 0.3s ease-out;
    width: calc(100% - 48px);
    z-index: ${Layers.Modal};

    [aria-active='true'] & {
      transform: translateX(0vw);
    }
  }
`;
const Close = styled.button `
  display: none;

  @media ${until(Device.TabletLarge)} {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    background: none;
    border: 0;
    color: ${brand.white};
    height: 48px;
    justify-content: center;
    margin: 0;
    padding: 0;
    transform: translateX(100%);
    width: 48px;

    > svg {
      display: block;
      height: 20px;
      width: 20px;
    }

    > span {
      ${srOnly};
    }
  }
`;
export default {
    ActiveFilters,
    ActiveFiltersBase,
    ActiveTab,
    Background,
    Checkbox,
    CheckboxFilterHolder,
    CheckboxInput,
    CheckboxLabel,
    ClearBtn,
    Close,
    Container,
    Filter,
    FilterBtn,
    FilterDropdown,
    FilterOptions,
    FilterOverflow,
    FilterSearch,
    FilterSearchBtn,
    FilterHolder,
    FilterList,
    ItemContainer,
    Overlay,
    SearchFilterBtnHolder,
    SelectLabel,
    Tick,
    Title,
};
